import React from 'react'
import { IIconProps } from 'Interfaces'

export function MinusIcon(props: IIconProps) {
    return (
        <svg width={props.width ?? 16} height={props.height ?? 16} viewBox='0 0 16 16' fill='none'>
            <path d="M14.7694 7.38477H1.23096V8.61553H14.7694V7.38477Z" fill="currentColor"/>        
        </svg>
    )
}